import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, inject, OnInit, Output, signal, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionTypeMenuComponent } from '../question-type-menu/question-type-menu.component';
import {
  CdkDrag,
  CdkDropList,
  CdkDropListGroup,
  CdkDragPlaceholder,
  CdkDragHandle,
} from '@angular/cdk/drag-drop';
import { QuestionFormComponent } from '../question-form/question-form.component';
import { AbstractControl, ControlValueAccessor, FormArray, FormBuilder, FormControl, FormsModule, isFormRecord, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator } from '@angular/forms';
import { Step } from 'src/app/models/step.model';
import { Question } from 'src/app/models/question.model';
import { EQuestionType, QuestionType } from 'src/app/models/questionType.model';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { QuestionnaireApiService } from 'src/app/services/questionnaire-api.service';
import { EStatus } from 'src/app/models/EnumStatus';
import { filter, map, tap, withLatestFrom } from 'rxjs';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { DragStore } from 'src/app/store/drag-store';
import { CollectionQuestionsComponent } from '../collection-questions/collection-questions.component';
import { DefinitionsInBoardComponent } from '../definitions-in-board/definitions-in-board.component';
import { QuestionComponent } from '../question/question.component';
import { QuestionDisplayComponent } from '../question-display/question-display.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { GlobalService } from 'src/app/shared/services/global-service';
import { WarpQuestionComponent } from '../warp-question/warp-question.component';
import { TostesStore } from 'src/app/store/tostes-store';
import { TostPositionEnum, TostTypeEnum } from 'src/app/shared/models/tostes.model';
import { MessagePopupComponent } from '../question-form/components/autocomplete-question/component/answer-option-item-input/message-popup/message-popup.component';
import { environment } from 'src/environment';
import { MatDialog } from '@angular/material/dialog';
import { AddApiNameFieldComponent } from '../question-form/components/add-api-name-field/add-api-name-field.component';
import { ChooseAutoFillFieldComponent } from '../question-form/components/choose-auto-fill-field/choose-auto-fill-field.component';
@Component({
    selector: 'que-question-board-edit',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: QuestionBoardEditComponent,
            multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: QuestionBoardEditComponent,
            multi: true
        }
    ],
    imports: [CommonModule,
        ReactiveFormsModule,
        FormsModule,
        CdkDrag,
        CdkDropList,
        TranslateDirective, TranslatePipe,
        DefinitionsInBoardComponent,
        CdkDragHandle,
        WarpQuestionComponent
    ],
    templateUrl: './question-board-edit.component.html',
    styleUrls: ['./question-board-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionBoardEditComponent implements OnInit, ControlValueAccessor, Validator {
  @Output() addingNowEvent: EventEmitter<boolean> = new EventEmitter()

  @ViewChild('itemToScroll') itemToScroll: ElementRef | undefined;


  #QuestionnaireApiService = inject(QuestionnaireApiService);
  #dragStore = inject(DragStore);
  #globalService = inject(GlobalService);
  #questionnaireStore = inject(QuestionnaireStore);
  #tostesStore = inject(TostesStore);

  questionnaireIdSig$ = toSignal(this.#questionnaireStore.questionnaireId$);
  currentStepIndex$ = toSignal(this.#questionnaireStore.currentStepIndex$);

  #dialog = inject(MatDialog);

  #builder = inject(FormBuilder);
  stepForm = this.#builder.group({
    id: new FormControl<number>(-2),
    title: new FormControl<string | null>(null),
    questions: this.#builder.array<Question>([]),
    status: new FormControl<EStatus>(0),
  });

  backColor$ = this.#questionnaireStore.backColor$;
  secondaryColor$ = this.#questionnaireStore.secondaryColor$;

  length$ = signal(0);
  questions$ = toSignal(this.stepForm.controls.questions.valueChanges.pipe(map(s => this.stepForm.controls.questions.controls)));
  registerOnChangeCallback: any = () => { };
  onValidationChangeCallBack: any;
  focusId$ = this.#dragStore.focusId$;

  eStatus = EStatus;
  ngOnInit(): void {

    this.stepForm.valueChanges.subscribe(step => {
      if (this.stepForm.controls.status.value != this.eStatus.Created && this.stepForm.controls.status.value != this.eStatus.Deleted) {
        this.stepForm.controls.status.setValue(this.eStatus.Changed, { emitEvent: false });
        this.registerOnChangeCallback({ ...step, status: this.eStatus.Changed });
      }
      else {
        this.registerOnChangeCallback(step);
      }
      this.length$.set(step.questions?.length ?? 0);
    });



    this.#dragStore.deleteFolloesQuestion$
      .pipe(filter(deleteFolloesQuestionsDetails => deleteFolloesQuestionsDetails != undefined))
      .subscribe((deleteFolloesQuestionsDetails) => {
        this.#dragStore.deleteFollowQuestionsByIds(undefined)
        if (this.stepForm.value?.id && this.questionnaireIdSig$()) {
          var questions = this.stepForm.controls.questions.value.filter(q => q?.followAnswerOptionItemGuid == deleteFolloesQuestionsDetails?.optionGuid || deleteFolloesQuestionsDetails?.questionIdes.includes(q?.id ?? -2));
          if (questions != null) {
            questions.forEach(question => {
              if (question!.status == this.eStatus.Saved || question!.status == this.eStatus.Changed) {
                var index = -1;
                this.stepForm.value.questions?.forEach((q, i) => {
                  if (q?.id == question?.id) {
                    index = i;
                  }
                })
                if (index != -1) {
                  this.stepForm.controls.questions.removeAt(index!);
                  this.#QuestionnaireApiService.deleteQuestionById(question!.id).subscribe(
                    (response) => {
                      this.#dragStore.resetFocusId();
                      //i need to cause it to be update in the html
                    }
                  );
                }
              }
            });
          }
        }
        else {
          console.error("error delete follow questios - because of the stepId or questionnaireId");
        }
      });

    this.#dragStore.apiExposureField$
      .pipe(
        tap(() => this.#dragStore.setApiExposureField(undefined)),
        filter(data => data != undefined && this.stepForm.controls.questions.value[data.index] != undefined)
      )
      .subscribe((data) => {
        const currentItem = this.stepForm.controls.questions.value[data!.index];
        const currentId = currentItem?.apiExposureFieldId ?? null;
        this.#dialog.open(AddApiNameFieldComponent,
          { data: { id: currentId, isEditMode: data!.isEditMode } },
        ).afterClosed()
          .subscribe((resultFromPopUp: number | null | undefined) => {
            const itemToUpdate = this.stepForm.controls.questions.at(data!.index);
            if (itemToUpdate && (resultFromPopUp !== null || !data!.isEditMode)) {
              const chosenId = typeof resultFromPopUp === 'number' ? resultFromPopUp : undefined;
              // Only save ID - name will be computed dynamically in display
              itemToUpdate!.patchValue({ ...itemToUpdate.value, apiExposureFieldId: chosenId } as Question);
            }
          })
      });
    this.#dragStore.isFilterField$
      .pipe(
        // tap(() => this.#dragStore.setUnauthorizedFilterField(undefined)),
        filter(data => data != undefined && this.stepForm.controls.questions.value[data.index] != undefined)
      )
      .subscribe((data) => {
        const selectedQuestion = this.stepForm.controls.questions.value[data!.index];

        // Clear isFilterField from all questions first (only one can be filter field)
        this.stepForm.controls.questions.controls.forEach((control, index) => {
          if (control.value?.isFilterField) {
            control.patchValue({ ...control.value, isFilterField: false } as Question);
          }
        });

        // Set the selected question as filter field with isFilterField flag
        const itemToUpdate = this.stepForm.controls.questions.at(data!.index);
        if (itemToUpdate && !data!.isEditMode && selectedQuestion) {
          itemToUpdate.patchValue({ ...itemToUpdate.value, isFilterField: true } as Question);
        }
      });

    this.#dragStore.autoFillField$
      .pipe(
        tap(() => this.#dragStore.setAutoFillField(undefined)),
        filter(data => data != undefined && this.stepForm.controls.questions.value[data.index] != undefined),
        withLatestFrom(this.#questionnaireStore.usedAutoFillFieldIds$)
      )
      .subscribe(([data, usedFields]) => {
        const currentItem = this.stepForm.controls.questions.value[data!.index];
        const currentId = currentItem?.autoFillFieldId ?? null;
        const usedFieldIds = usedFields
          .filter(u => u.questionId !== currentItem?.id)
          .map(u => u.autoFillFieldId);
        this.#dialog.open(ChooseAutoFillFieldComponent,
          { data: { id: currentId, isEditMode: data!.isEditMode, usedFieldIds } },
        ).afterClosed()
          .subscribe((resultFromPopUp: number | null | undefined) => {
            const itemToUpdate = this.stepForm.controls.questions.at(data!.index);
            if (itemToUpdate && (resultFromPopUp !== null || !data!.isEditMode)) {
              const chosenId = typeof resultFromPopUp === 'number' ? resultFromPopUp : undefined;
              itemToUpdate!.patchValue({ ...itemToUpdate.value, autoFillFieldId: chosenId } as Question);
            }
          })
      });

  }
  onCenterMouseDown() {
    this.#dragStore.onCenterMouseDown(true);
  }

  addQuestion(question: Question) {
    this.stepForm.controls.questions.push(new FormControl<Question>(question));
  }
  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    if (this.stepForm.valid) {
      return null;
    }
    return { 'stepForm': "not-valid" }
  }
  writeValue(obj: Step): void {
    this.length$.set(-1);
    this.length$.set(obj.questions.length);
    this.stepForm.controls.id.setValue(obj.id, { emitEvent: false });
    this.stepForm.controls.questions.clear({ emitEvent: false })
    for (let i of obj.questions) {
      this.addQuestion(i)
    }
    this.stepForm.controls.title.setValue(obj.title ?? null, { emitEvent: false });
  }
  noCreateComponent(index: any, item: any) {
    return index;
  }
  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChangeCallBack = fn;
  }
  registerOnChange(fn: any): void {
    this.registerOnChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
  }
  deleteQuestion(index: number) {
    var question = this.stepForm.controls.questions.value[index!];
    if (question != null) {
      var followQuestionsIdes = question.optionsList?.answerOptionItem?.filter(x => x.followQuestionChildsIdes != undefined).flatMap(x => x.followQuestionChildsIdes).filter(x => x != undefined);
      if (followQuestionsIdes && followQuestionsIdes.length > 0) {
        this.#dialog.open(MessagePopupComponent, { data: environment.lang == 'he' ? { message: "האם אתה בטוח שברצונך למחוק שאלה זו?", message2: ".שים לב: שאלות ההמשך שמקושרות לשאלה זה ימחקו גם הן" } : { message: "Are you sure you want to delete this question?", message2: "Note that follow-up questions linked to this question will also be deleted" } })
          .afterClosed().subscribe(
            x => {
              if (x == true) {
                if (followQuestionsIdes != undefined) {
                  let x = this.stepForm.controls.questions.value.filter(q => !followQuestionsIdes!.includes(q?.id ?? 0) && q != null);
                  if (this.stepForm.controls.questions) {
                    this.stepForm.controls.questions.clear();
                    x.forEach(y => {
                      this.stepForm.controls.questions.push(new FormControl<Question>(y!));
                    })
                  }
                }

              }
              this.deleteQuestionAfterCheck(index);
            })
      }
      else {
        this.deleteQuestionAfterCheck(index);
      }
    }
  }
  deleteQuestionAfterCheck(index: number) {
    var question = this.stepForm.controls.questions.value[index!];
    if (question != null) {
      if (question!.status != this.eStatus.Saved && question!.status != this.eStatus.Changed) {
        this.stepForm.controls.questions.removeAt(index!);
        if (question.parentFollowUpQuestionId != null) {
          this.stepForm.controls.questions.setValue(
            this.stepForm.controls.questions.value.map(
              q => {
                if (q?.id == question?.parentFollowUpQuestionId) {
                  return { ...q, optionsList: { ...q?.optionsList, answerOptionItem: q?.optionsList?.answerOptionItem?.map(ans => { return { ...ans, followQuestionChildsIdes: [...(ans.followQuestionChildsIdes?.filter(x => x != question?.id) ?? [])] } }) } } as Question
                };
                return q;
              })
          )
        }
        this.#dragStore.resetFocusId();
      }
      else {
        if (question!.status == this.eStatus.Saved || question!.status == this.eStatus.Changed) {
          this.stepForm.controls.questions.removeAt(index!);
          if (question.parentFollowUpQuestionId != null) {
            this.stepForm.controls.questions.setValue(
              this.stepForm.controls.questions.value.map(
                q => {
                  if (q?.id == question?.parentFollowUpQuestionId) {
                    return { ...q, optionsList: { ...q?.optionsList, answerOptionItem: q?.optionsList?.answerOptionItem?.map(ans => { return { ...ans, followQuestionChildsIdes: [...(ans.followQuestionChildsIdes?.filter(x => x != question?.id) ?? [])] } }) } } as Question
                  };
                  return q;
                })
            )
          }
          this.#QuestionnaireApiService.deleteQuestionById(question!.id).subscribe(
            (response) => {
              this.#dragStore.resetFocusId();
              //i need to cause it to be update in the html
            }
            , (error: Error) => {
              // console.log("ארעה שגיאה במחיקה", error)
            }
          );
        }
      }
    }
  }

  duplicate(index: number) {
    this.addingNowEvent.emit(true);
    var currentIndex = this.currentStepIndex$();
    var question = { ...this.stepForm.controls.questions.controls[index].value, id: 0, status: this.eStatus.Created } as Question;
    var newQuestion = this.#globalService.changeGuidsOfQuestions(question).question;
    if (this.stepForm.value?.id && this.questionnaireIdSig$()) {
      this.#QuestionnaireApiService.createQuestion(this.stepForm.value?.id, this.questionnaireIdSig$()!, index + 1, newQuestion)
        .subscribe(idFromServer => {
          if (currentIndex == this.currentStepIndex$()) {
            var newIndex = index + 1;
            var questionId = this.stepForm.controls.questions.controls[index].value?.id;
            while (this.stepForm.controls.questions.controls[newIndex]?.value?.parentFollowUpQuestionId == (questionId ?? 1)) {
              newIndex++
            }
            this.stepForm.controls.questions.insert(newIndex, new FormControl<Question>({ ...newQuestion, id: idFromServer, status: this.eStatus.Saved }));
            this.length$.set(this.stepForm.value?.questions?.length ?? 0);
            this.#dragStore.updatFocusId(newIndex);
          }
          else {
            // this.#questionnaireStore.
          }
          this.addingNowEvent.emit(false);
        });
    }

  }
  // addQuestionsFromCollection(ev: Question[]) {
  //   ev.forEach(q => this.addQuestion({ ...q, collectionQuestionId: q.id, id: 0, status: this.eStatus.Created }));
  //   if (this.stepForm.controls.status.value != this.eStatus.Created && this.stepForm.controls.status.value != this.eStatus.Deleted) {
  //     this.stepForm.controls.status.setValue(this.eStatus.Changed, { emitEvent: false });
  //     this.registerOnChangeCallback({ ...this.stepForm.value, status: this.eStatus.Changed });
  //     // this.#questionnaireStore.updateWasChange();
  //   }
  //   else {
  //     // this.#questionnaireStore.updateWasChange();
  //     this.registerOnChangeCallback(this.stepForm.value);
  //   }
  //   this.#dragStore.openAndCloseCollectionQuestions(false);
  // }
  drop(event: any) {
    if (event.previousContainer === event.container) {
      const newIndex = event.currentIndex > event.previousIndex ? event.currentIndex : event.currentIndex;
      const isDown = event.currentIndex > event.previousIndex;
      const controlToMove = this.stepForm.controls.questions.controls[event.previousIndex];
      if (this.stepForm.controls.questions.controls[newIndex + (isDown ? 1 : 0)]?.value?.parentFollowUpQuestionId != null) {
        if (this.stepForm.controls.questions.controls[newIndex + (isDown ? 1 : 0)]?.value?.parentFollowUpQuestionId != controlToMove.value?.id) {
          this.#tostesStore.addTost({ guid: this.#tostesStore.generateGuid(), message: { en: "It is not possible to separate a question from its follow-up questions", he: "אין אפשרות להפריד בין שאלה לשאלות ההמשך שלה" }, position: TostPositionEnum.BottomLeft, seconds: 2, type: TostTypeEnum.ERROR })
        }
      } else {
        if ((controlToMove.value?.type.id == EQuestionType.Mark || controlToMove.value?.type.id == EQuestionType.Multi || controlToMove.value?.type.id == EQuestionType.Autocomplete)
          && (controlToMove.value.optionsList?.answerOptionItem?.some(ans => ans.followQuestionChildsIdes?.length ?? 0 > 0))
        ) {
          var followsControlsToMove = this.stepForm.controls.questions.controls.filter(c => c.value?.parentFollowUpQuestionId == controlToMove.value?.id);
          if (isDown) {
            this.stepForm.controls.questions.removeAt(event.previousIndex);
            this.stepForm.controls.questions.insert(newIndex, controlToMove);
            followsControlsToMove.forEach(element => {
              this.stepForm.controls.questions.removeAt(event.previousIndex);
              this.stepForm.controls.questions.insert(newIndex, element);
            });
          }
          else {
            //up
            this.stepForm.controls.questions.removeAt(event.previousIndex);
            this.stepForm.controls.questions.insert(newIndex, controlToMove);
            var index = 1;
            followsControlsToMove.forEach(element => {
              this.stepForm.controls.questions.removeAt(event.previousIndex + index);
              this.stepForm.controls.questions.insert(newIndex + index, element);
              index++;
            });
          }
        }
        else {
          this.stepForm.controls.questions.removeAt(event.previousIndex);
          this.stepForm.controls.questions.insert(newIndex, controlToMove);
          this.length$.set(this.stepForm.value?.questions?.length ?? 0);
          this.#dragStore.updatFocusId(event.currentIndex);
          this.stepForm.controls.questions.setValue(this.stepForm.controls.questions.value, { emitEvent: true });
        }
      }
    } else {
      this.addingNowEvent.emit(true);
      const type = event.item.data as QuestionType;
      var question = { id: 0, status: this.eStatus.Created, ...this.#globalService.getQuestionFromDefaulteArrByType(type?.id), type: type }
      //, isFocus: true 
      if (this.stepForm.value?.id && this.questionnaireIdSig$()) {
        this.#QuestionnaireApiService.createQuestion(this.stepForm.value?.id, this.questionnaireIdSig$()!, 0, question)
          .subscribe(idFromServer => {
            this.stepForm.controls.questions.insert(event.currentIndex, new FormControl<Question>({ ...question, id: idFromServer, status: this.eStatus.Saved }));
            this.length$.set(this.stepForm.value?.questions?.length ?? 0);
            this.#dragStore.updatFocusId(event.currentIndex);
            this.addingNowEvent.emit(false);
          });
      }
    }
    this.#dragStore.updatDragType(null);
  }
  onDragEntered(event: any) {
    this.#dragStore.updatDragType(event.item.data);
  }
  onDragExit() {
    this.#dragStore.updatDragType(null);
  }
  focus(event: Event, index: number) {
    this.#dragStore.updatFocusId(index);
    event.stopPropagation();
  }


  getOptionToQuestionById(questionId?: number, optionGuid?: string) {
    if (questionId && optionGuid) {
      var question = this.stepForm.value.questions?.find(q => q?.id == questionId);
      var option = question?.optionsList?.answerOptionItem?.find(op => op.guid == optionGuid);
      return option?.name ?? "";
    }
    return "";
  }
  ddd(i: any, item: any) {
    return item;
  }

}